import { render } from "./FourthBar.vue?vue&type=template&id=0ff1321c&scoped=true"
import script from "./FourthBar.vue?vue&type=script&lang=js"
export * from "./FourthBar.vue?vue&type=script&lang=js"

import "./FourthBar.vue?vue&type=style&index=0&id=0ff1321c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff1321c"]])

export default __exports__